// extracted by mini-css-extract-plugin
module.exports = {"logo":"NavBar_logo__24ls7"};